<section class="atmos-draft-warning atmos-card">
  <div class="atmos-draft-warning__body atmos-card__body">
    <mat-icon>warning</mat-icon>
    <span>{{ message() }}</span>
  </div>
</section>
